// frontend/src/utils/flipBookGeometry.js
import { isLeftPage, facingPageIndex } from './pageParity';

// Geometrie partagee entre tous les feuilletages reels (page-flip) du site
// — Apercu final (BookPreviewFinalLuxe.js) et Atelier (BookAtelierLuxe.js/
// AtelierFlipBookView.js) : extrait de BookPreviewFinalLuxe.js (premier a
// l'avoir implemente et verifie a l'ecran, 2026-10-11) pour que l'Atelier
// reutilise exactement la meme regle plutot que d'en ecrire une seconde
// version qui pourrait diverger.
//
// LA REGLE (miroir de utils/pageParity.js, jamais reimplementee autrement
// ici) : la page de contenu 0 ("page 1") est seule a droite, face au
// CONTRE-PLAT de la couverture — un feuillet INERTE, pas une page de
// contenu. Symetrique en fin de livre : la derniere page de contenu est
// seule a gauche, face au contre-plat de la 4e de couverture. Sans ces deux
// feuillets, page-flip pairerait la page 1 directement avec la couverture
// (centree, sans qu'on comprenne pourquoi elle est seule) et la derniere
// page directement avec la 4e de couverture (physiquement faux : la
// derniere feuille fait face a l'INTERIEUR de la 4e, pas a son texte
// exterieur) — les deux verifies a l'ecran avant correction.
export const FLIP_COVER_INDEX = 0;
export const FLIP_CONTREPLAT_INDEX = 1;

// Sequence de "feuilles" donnee a page-flip : couverture, contre-plat,
// une feuille par page interieure, contre-plat arriere, 4e de couverture.
export function buildFlipEntries(totalPages) {
  const entries = [
    { kind: 'cover' },
    { kind: 'contreplat' }
  ];
  for (let i = 0; i < totalPages; i += 1) entries.push({ kind: 'interior', pageIndex: i });
  entries.push({ kind: 'contreplat' });
  entries.push({ kind: 'back-cover' });
  return entries;
}

// Longueur de la sequence ci-dessus (sans la construire) — pratique pour
// turnToPage(flipBackCoverIndex(...)) ou bornes de navigation.
export function flipEntryCount(totalPages) {
  return totalPages + 4;
}

export function flipBackCoverIndex(totalPages) {
  return totalPages + 3;
}

// A partir de l'index que page-flip rapporte comme "courant", quelle page
// de CONTENU (0-indexee) cela designe-t-il ? Les deux contre-plats
// partagent le MEME vis-a-vis que la page de contenu la plus proche :
// page-flip peut rapporter l'un ou l'autre selon l'etat d'anime, les deux
// doivent donc resoudre vers cette page de contenu. null pour la
// couverture/4e (pas des pages de contenu).
export function contentPageFromFlipIndex(flipIndex, totalPages) {
  if (flipIndex === FLIP_CONTREPLAT_INDEX) return totalPages > 0 ? 0 : null;
  if (flipIndex === totalPages + 2) return totalPages > 0 ? totalPages - 1 : null;
  const pageIndex = flipIndex - 2;
  return pageIndex >= 0 && pageIndex < totalPages ? pageIndex : null;
}

// Reciproque : index page-flip d'une page de contenu donnee (pour
// turnToPage depuis un lien profond ?page=X ou un clic sur la pellicule).
export function flipIndexFromContentPage(pageIndex) {
  return pageIndex + 2;
}

// Vis-a-vis complet (gauche/droite) pour une page de contenu donnee —
// reutilise directement utils/pageParity.js (isLeftPage/facingPageIndex),
// jamais une deuxieme implementation de la regle de parite.
export function describeContentSpread(pageIndex, totalPages) {
  if (pageIndex == null) return { leftPage: null, rightPage: null };
  const facing = facingPageIndex(pageIndex);
  if (isLeftPage(pageIndex)) {
    return { leftPage: pageIndex, rightPage: facing != null && facing < totalPages ? facing : null };
  }
  return { leftPage: facing, rightPage: pageIndex };
}
